<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card mt-3">
                    <div class="card-header">
                        <h5 class="mb-0">Modify Role</h5>
                    </div>
                    <div class="card-body">
                        <p class="text-muted">
                            Change your own role for your current branch. This updates your
                            role and user type, which changes your permissions immediately.
                        </p>

                        <div class="row">
                            <div class="col-md-5 mb-3">
                                <label class="form-label">Role</label>
                                <select class="form-select" v-model="roleId">
                                    <option value="">-- Select role --</option>
                                    <option v-for="r in roles" :key="r.id" :value="r.id">{{ r.name }}</option>
                                </select>
                            </div>

                            <div class="col-md-4 mb-3 d-flex align-items-end">
                                <button class="btn btn-success" :disabled="!roleId || loading" @click="updateRole">
                                    <span v-if="loading">Updating...</span>
                                    <span v-else>Update</span>
                                </button>
                            </div>
                        </div>

                        <div v-if="message" class="alert mt-2" :class="isError ? 'alert-danger' : 'alert-success'">
                            {{ message }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'modify-my-role',
    data() {
        return {
            roles: [],
            roleId: '',
            loading: false,
            message: '',
            isError: false,
        };
    },
    mounted() {
        this.getRoles();
    },
    methods: {
        getRoles() {
            const self = this;
            axios.get('api/modules/user-roles/my-branch-roles')
                .then(function (response) {
                    self.roles = response.data.items || [];
                    if (response.data.current_role_id) {
                        self.roleId = response.data.current_role_id;
                    }
                })
                .catch(function (err) { console.warn(err); });
        },
        updateRole() {
            const self = this;
            self.loading = true;
            self.message = '';
            self.isError = false;
            axios.post('api/modules/user-roles/modify-my-role', { role_id: self.roleId })
                .then(function (response) {
                    self.loading = false;
                    self.message = response.data.message;
                    // Refresh the cached user + permissions, then reload so the new
                    // role takes effect across the app (menu/permissions).
                    self.$store.commit('setUser');
                    setTimeout(function () { self.$router.go(0); }, 800);
                })
                .catch(function (err) {
                    self.loading = false;
                    self.isError = true;
                    self.message = (err.response && err.response.data && err.response.data.message)
                        ? err.response.data.message
                        : 'Failed to update role.';
                });
        },
    },
};
</script>
